import { IconsProps } from '@/types/shared'
import React from 'react'

const PendingIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
            >
                <path
                    d="M5.64404 8.5H19.644V6.5H5.64404V8.5ZM5.64404 22.5C5.09404 22.5 4.62321 22.3042 4.23154 21.9125C3.83988 21.5208 3.64404 21.05 3.64404 20.5V6.5C3.64404 5.95 3.83988 5.47917 4.23154 5.0875C4.62321 4.69583 5.09404 4.5 5.64404 4.5H6.64404V2.5H8.64404V4.5H16.644V2.5H18.644V4.5H19.644C20.194 4.5 20.6649 4.69583 21.0565 5.0875C21.4482 5.47917 21.644 5.95 21.644 6.5V12.175C21.3274 12.025 21.0024 11.9 20.669 11.8C20.3357 11.7 19.994 11.625 19.644 11.575V10.5H5.64404V20.5H11.944C12.0607 20.8667 12.1982 21.2167 12.3565 21.55C12.5149 21.8833 12.7024 22.2 12.919 22.5H5.64404ZM18.644 23.5C17.2607 23.5 16.0815 23.0125 15.1065 22.0375C14.1315 21.0625 13.644 19.8833 13.644 18.5C13.644 17.1167 14.1315 15.9375 15.1065 14.9625C16.0815 13.9875 17.2607 13.5 18.644 13.5C20.0274 13.5 21.2065 13.9875 22.1815 14.9625C23.1565 15.9375 23.644 17.1167 23.644 18.5C23.644 19.8833 23.1565 21.0625 22.1815 22.0375C21.2065 23.0125 20.0274 23.5 18.644 23.5ZM20.319 20.875L21.019 20.175L19.144 18.3V15.5H18.144V18.7L20.319 20.875Z"
                    fill={props?.color || '#FFA726'}
                />
            </svg>
        </div>
    )
}

export default PendingIcons
